/**
 * The device's own memory of which moments it has opened (BUG-117).
 *
 * The server's books are honest, but the path to them isn't always fresh: on
 * a cold launch from a push, the service worker can hand back a stale unread
 * list that still contains a moment this phone viewed minutes ago — and the
 * prefetch caches will happily show it again. A view-once moment played
 * twice on exactly that route. The unread run is therefore filtered through
 * this ledger: a moment THIS device has view-marked never re-enters its own
 * play queue, whatever a cached list claims.
 *
 * localStorage, capped: the server hard-deletes a consumed moment minutes
 * after viewing, so old entries are dead weight, not history.
 */

const KEY = 'momento-viewed-moments';
const MAX_ENTRIES = 300;

function read(): number[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((v) => typeof v === 'number') : [];
  } catch {
    return [];
  }
}

function write(ids: number[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids.slice(-MAX_ENTRIES)));
  } catch {
    /* storage full or unavailable — the server-side filter still stands */
  }
}

export const viewedLedger = {
  markViewed(id: number): void {
    const ids = read();
    if (ids.includes(id)) return;
    ids.push(id);
    write(ids);
  },

  hasViewed(id: number): boolean {
    return read().includes(id);
  },
};
